import { useState } from 'react'
import { Link } from 'react-router-dom'
import { formatCoinsNum } from '../lib/format.js'
import WeaponArt from './WeaponArt.jsx'
import CoinIcon from './CoinIcon.jsx'
import defaultCaseImg from '../assets/testcase.png'

export default function CaseCard({ caseData }) {
  const best = caseData.contents?.[0]
  const [imgSrc, setImgSrc] = useState(caseData.image || defaultCaseImg)

  return (
    <Link
      to={`/cases/${caseData.id}`}
      className="case-item"
      style={{
        '--accent': caseData.accent || '#8b5cf6',
        '--rarity': best ? `var(--rarity-${best.rarity})` : 'var(--purple)',
      }}
    >
      {/* 1. Название кейса НАД пнг кейса */}
      <span className="case-item-title-top">{caseData.name}</span>

      {/* 2. Зона кейса */}
      <div className="case-item-art">
        {/* Свечение ЗА кейсом под его акцентный цвет */}
        <div className="case-item-glow" />

        {/* Фото кейса */}
        <img
          src={imgSrc}
          alt={caseData.name}
          className="case-item-box"
          draggable="false"
          onError={() => setImgSrc(defaultCaseImg)}
        />
      </div>

      {/* 3. Цена ПОД кейсом в CM COIN */}
      <div className="case-item-price-wrapper">
        <span className="case-item-price">
          <span className="case-price-num">{formatCoinsNum(caseData.priceKopecks)}</span>
          <CoinIcon size="sm" className="case-price-coin" />
        </span>
      </div>
    </Link>
  )
}

